import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  token: '',
  provinces: [],
  allProvinces: [],
  totalPages: 0,
  totalRecords: 0,
  province: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_79: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Provinces(state, provinces) {
    state.provinces = provinces.items;
    state.totalPages = provinces.totalPages;
    state.totalRecords = provinces?.totalRecords ?? 0;
  },
  SET_AllProvinces(state, provinces) {
    state.allProvinces = provinces;
  },
  SET_Province(state, province) {
    state.province = province;
  },
};
const actions = {
  errorProvince({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllProvinces({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Provinces/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllProvinces', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorProvince', error);
      });
  },
  addProvince({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Provinces', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorProvince', error);
      });
  },
  getProvince({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Provinces/ById?provinceId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Province', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorProvince', error);
      });
  },
  editProvince({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Provinces/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorProvince', error);
      });
  },
  deleteProvince({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Provinces/Remove?provinceId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorProvince', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
